module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isTransformer.js
// module id = 116
// module chunks = 35783957827783 114276838955818